import { createContext, useState, useEffect } from "react";
import axios from "../api/axios";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
     const [auth, setAuth] = useState({});

    // const [auth, setAuth] = useState(() => {
    //     try {
    //         const stored = localStorage.getItem("auth");
    //         return stored ? JSON.parse(stored) : {};
    //     } catch {
    //         return {};
    //     }
    // });

    // const setAuthPersisted = (value) => {
    //     try {
    //         if (value && Object.keys(value).length > 0) {
    //             localStorage.setItem("auth", JSON.stringify(value));
    //         } else {
    //             localStorage.removeItem("auth");
    //         }
    //     } catch (err) {
    //         console.error("Failed to persist auth:", err);
    //     }
    //     setAuth(value);
    // };

    // return (
    //     <AuthContext.Provider value={{ auth, setAuth: setAuthPersisted }}>
    //         {children}
    //     </AuthContext.Provider>
    // )

     return (
        <AuthContext.Provider value={{ auth, setAuth }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;